import cn from "classnames"

import { Statistic, type StatisticProps } from "@/atoms"

import styles from "./HeaderDeploymentsTab.module.scss"

export const StatisticWidget = ({ className, ...props }: StatisticProps) => (
  <Statistic className={cn(styles.statistic, className)} {...props} />
)
